import { getLoaders } from 'entities/_config';

import { apiCall } from 'services/api';
import { UserDashboard } from './types';

export const usersLoaders = getLoaders({
  dashboard: {
    load: async (): Promise<UserDashboard> => {
      return apiCall({
        path: '/users/dashboard',
        method: 'get',
      });
    },
  },

  emailConfirmation: {
    load: async (): Promise<{ enabled: boolean; rewardPoints: number }> => {
      return apiCall({
        path: '/users/email-confirmation/status',
        method: 'get',
      });
    },
  },
});
